import React from 'react';
import {
  ActionPill, StatusBadge, WorkspaceCard, WorkspaceChip, useLayeredModal
} from './LayeredWorkspace';

function ActionGuide() {
  const { closeTop } = useLayeredModal();
  return (
    <div className="cp-reference-detail">
      <StatusBadge tone="ready">READY</StatusBadge>
      <h3>Action pills stay close to their card</h3>
      <p>Later programme surfaces use short, explicit actions with meaningful names. This guide changes no encounter data.</p>
      <div className="cp-action-row">
        <ActionPill primary onClick={closeTop}>Keep Current</ActionPill>
        <ActionPill onClick={closeTop}>Back</ActionPill>
      </div>
    </div>
  );
}

function EncounterDetail({ encounterName, currentRound }) {
  const { openLayer, closeTop } = useLayeredModal();
  return (
    <div className="cp-reference-detail">
      <StatusBadge tone="active">ACTIVE</StatusBadge>
      <h3>{encounterName}</h3>
      <dl className="cp-reference-facts">
        <div><dt>Status</dt><dd>Active encounter</dd></div>
        <div><dt>Time</dt><dd>Round {currentRound}</dd></div>
        <div><dt>Visibility</dt><dd>DM workspace</dd></div>
        <div><dt>Ownership</dt><dd>Current Combat PRO session</dd></div>
      </dl>
      <div className="cp-action-row">
        <ActionPill primary onClick={function () {
          openLayer({
            title: 'Action Guide', eyebrow: 'Encounter Workspace',
            subtitle: 'A third deterministic layer inside Combat PRO.', content: <ActionGuide />
          });
        }}>More Info</ActionPill>
        <ActionPill onClick={closeTop}>Back</ActionPill>
      </div>
    </div>
  );
}

function ReferenceOverview({ encounterName, currentRound }) {
  const { openLayer } = useLayeredModal();
  return (
    <div className="cp-reference-overview">
      <p className="cp-layer-intro">A read-only workspace for the active encounter. Open a card to inspect it without leaving Combat PRO or resetting combat state.</p>
      <div className="cp-workspace-grid">
        <WorkspaceCard
          title={encounterName}
          type="Encounter context"
          source="Combat PRO"
          status="ACTIVE"
          summary={'Round ' + currentRound + ' remains live behind this workspace.'}
          meta="Visibility: DM workspace"
          onOpen={function () {
            openLayer({
              title: encounterName, eyebrow: 'Encounter Workspace',
              subtitle: 'Current context, presented without raw identifiers.',
              content: <EncounterDetail encounterName={encounterName} currentRound={currentRound} />
            });
          }}
        />
        <WorkspaceCard
          title="Card and action guide"
          type="Reference"
          source="Combat PRO"
          status="READY"
          summary="Readable summaries open into detail layers; actions remain explicit pills."
          meta="No encounter changes"
          onOpen={function () {
            openLayer({
              title: 'Card and Action Guide', eyebrow: 'Encounter Workspace',
              subtitle: 'Reusable card, status and action language.', content: <ActionGuide />
            });
          }}
        />
      </div>
    </div>
  );
}

export default function LayeredWorkspaceReference({ encounterName, currentRound }) {
  const { openLayer } = useLayeredModal();
  return (
    <WorkspaceChip label="Open encounter workspace" onClick={function () {
      openLayer({
        title: 'Encounter Workspace', eyebrow: 'Current Encounter',
        subtitle: 'Read-only layered context for ' + encounterName,
        content: <ReferenceOverview encounterName={encounterName} currentRound={currentRound} />
      });
    }}>Workspace</WorkspaceChip>
  );
}
